module.exports = __webpack_public_path__ + "img/E7E2D8_B1AA9D_C9C2B3_BCB4AC-256px.fd307fbd.png";